import React from 'react'

export type LoadingProps = {
  className?: string
  modifiers?: 'small'
  testId?: string
}

export const Loading: React.FC<LoadingProps> = props => {
  const { className, modifiers, testId } = props

  const classNames = []
  if (className) {
    classNames.push(className)
  }
  if (modifiers === 'small') {
    classNames.push('Loading--small')
  }

  return (
    <div
      className={`Loading ${classNames.join(' ')}`}
      data-testid={testId ? `${testId}-loading` : undefined}
    >
      <div className="Loading-indicator"></div>
      <div className="Loading-indicator"></div>
      <div className="Loading-indicator"></div>
    </div>
  )
}
